import request from 'oc-request';

export default () => ({
    email: null,
    password: null,
    password_confirmation: null,
    first_name: null,
    last_name: null,
    code: null,
    errors: {},
    commonError: null,

    handleError(response, defaultMessage = 'Ошибка') {
        this.errors = {};
        this.commonError = null;

        if (response.X_OCTOBER_ERROR_FIELDS) {
            this.errors = response.X_OCTOBER_ERROR_FIELDS;
            this.commonError = response.X_OCTOBER_ERROR_MESSAGE;
            return;
        }

        this.commonError = defaultMessage;
    },

    // Прямой AJAX запрос без использования oc-request
    directAjaxRequest(url, data, onSuccess, onError) {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('X-OCTOBER-REQUEST-HANDLER', 'MyRegistration::onRegister');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        
        // Добавляем CSRF токен, если он есть
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
            xhr.setRequestHeader('X-CSRF-TOKEN', csrfToken);
        }
        
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                // Успешный ответ
                onSuccess(JSON.parse(xhr.responseText));
            } else {
                // Ошибка, но с доступом к телу ответа
                try {
                    const errorResponse = JSON.parse(xhr.responseText);
                    onError(errorResponse);
                } catch (e) {
                    onError({ error: xhr.statusText });
                }
            }
        };
        
        xhr.onerror = () => {
            onError({ error: 'Ошибка соединения' });
        };
        
        xhr.send(JSON.stringify(data));
    },

    signup() {
        this.errors = {};
        this.commonError = null;
        
        // Данные для регистрации
        const data = {
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation,
            first_name: this.first_name,
            last_name: this.last_name,
        };
        
        // Используем прямой AJAX-запрос вместо oc-request
        this.directAjaxRequest(
            '/account/signup/', // URL для формы регистрации
            data,
            // Обработчик успеха
            (response) => {
                window.location.href = '/';
            },
            // Обработчик ошибки, но с доступом к телу ответа
            (errorResponse) => {
                console.log('Error response:', errorResponse);
                this.handleError(errorResponse, 'Ошибка регистрации, проверьте правильность введенных данных');
            }
        );
    },

    signin() {
        this.errors = {};
        this.commonError = null;
        request.sendData('authentication::onLogin', {
            data: {
                email: this.email,
                password: this.password
            },
            success: () => window.location.href = '/',
            error: (response) => this.handleError(response, 'Неверный логин или пароль'),
            loading: '.preloader-selector'
        });
    },

    recoverPassword() {
        this.errors = {};
        this.commonError = null;
        request.sendData('authentication::onRecoverPassword', {
            data: { email: this.email },
            success: () => {
                alert('На ваш email отправлена инструкция по восстановлению пароля');
                window.location.href = '/account';
            },
            error: (response) => this.handleError(response, 'Проверьте правильность введенных данных'),
            loading: '.preloader-selector'
        });
    },

    resetPassword() {
        this.errors = {};
        this.commonError = null;
        request.sendData('resetPassword::onResetPassword', {
            data: {
                token: this.code,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation
            },
            success: () => {
                alert('Ваш пароль успешно изменен');
                window.location.href = '/account';
            },
            error: (response) => this.handleError(response, 'Ошибка сброса пароля'),
            loading: '.preloader-selector'
        });
    },

    updateProfile() {
        this.errors = {};
        this.commonError = null;
        request.sendData('account::onUpdateProfile', {
            data: {
                first_name: this.first_name,
                last_name: this.last_name,
            },
            success: () => {
                window.location.href = '/settings/profile/';
            },
            error: (response) => {
                this.handleError(response);
            }
        });
    },

    jsAuthLogout() {
        request.sendData('MySession::onLogout', {
            loading: '.preloader-selector'
        });
    }
});